export const kinescopeDictionary = {
  invalidVideoNotificationMessage: "Videoning formati mp4 va webm bo'lishi kerak",
  uploadText: 'Video yuklash uchun ushbu hududga bosing',
  uploadHint: "mp4, mov va webm formatdagi videolarni qo'llab quvvatlaydi",
  requiredLesson: 'Darsni tanlashingiz shart!',
  selectLesson: 'Darsni tanlang',
  requiredLessonName: 'Video nomini tanlash shart!',
  videoName: 'Video nomi',
}
